import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaBox, FaSignInAlt, FaSignOutAlt, FaClipboardList,
  FaUser, FaBars, FaTimes, FaChevronDown, FaExchangeAlt,
  FaDollarSign, FaShoppingCart
} from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import logo from "./assets/logo.png";

const Navbar = () => {
  const { isAuthenticated, isAdmin, logout } = useContext(AuthContext);
  const [menuAberto, setMenuAberto] = useState(false);
  const [dropdownAberto, setDropdownAberto] = useState(false);
  const [dropdownProdutos, setDropdownProdutos] = useState(false);
  const [dropdownGuia, setDropdownGuia] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
    if (!menuAberto) {
      setDropdownAberto(false);
      setDropdownProdutos(false);
      setDropdownGuia(false);
    }
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropdownAberto(!dropdownAberto);
    setDropdownProdutos(false);
    setDropdownGuia(false);
  };

  const toggleDropdownProdutos = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropdownProdutos(!dropdownProdutos);
    setDropdownAberto(false);
    setDropdownGuia(false);
  };

  const toggleDropdownGuia = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropdownGuia(!dropdownGuia);
    setDropdownAberto(false);
    setDropdownProdutos(false);
  };

  const fecharMenu = () => {
    setMenuAberto(false);
    setDropdownAberto(false);
    setDropdownProdutos(false);
    setDropdownGuia(false);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-left">
          <img src={logo} alt="Logo Cliente" className="navbar-logo" />
          <div className="navbar-header">
            <span className="navbar-title">Gestão de Estoque</span>
            <button className="menu-toggle lg:hidden" onClick={toggleMenu}>
              {menuAberto ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        <ul className={`navbar-menu ${menuAberto ? "active" : ""}`}>
          {/* Dropdown Produtos */}
          <li className={`navbar-dropdown ${dropdownProdutos ? "active" : ""}`}>
            <button className="nav-link" onClick={toggleDropdownProdutos}>
              <FaBox /> PRODUTOS <FaChevronDown />
            </button>
            <ul className="navbar-dropdown-content">
              <li onClick={fecharMenu}>
                <Link to="/" className="dropdown-item">COM CONTROLE</Link>
              </li>
              <li onClick={fecharMenu}>
                <Link to="/produtos-sem-controle" className="dropdown-item">SEM CONTROLE</Link>
              </li>
              <li onClick={fecharMenu}>
                <Link to="/embalagens" className="dropdown-item">📦 EMBALAGENS</Link>
              </li>
            </ul>
          </li>

          <li onClick={fecharMenu}>
            <Link to="/entrada" className="nav-link"><FaSignInAlt /> ENTRADA</Link>
          </li>
          
          <li onClick={fecharMenu}>
            <Link to="/saida" className="nav-link"><FaSignOutAlt /> SAÍDA</Link>
          </li>

          {/* Dropdown Relatórios */}
          <li className={`navbar-dropdown ${dropdownAberto ? "active" : ""}`}>
            <button className="nav-link" onClick={toggleDropdown}>
              <FaClipboardList /> RELATÓRIOS <FaChevronDown />
            </button>
            <ul className="navbar-dropdown-content">
              <li onClick={fecharMenu}><Link to="/estoque" className="dropdown-item">INVENTÁRIO</Link></li>
              <li onClick={fecharMenu}><Link to="/alertas" className="dropdown-item">BAIXO ESTOQUE</Link></li>
              <li onClick={fecharMenu}><Link to="/lotes" className="dropdown-item">CONTROLE DE LOTES</Link></li>
              <li onClick={fecharMenu}><Link to="/movimentacoes" className="dropdown-item"><FaExchangeAlt /> MOVIMENTAÇÕES</Link></li>
              <li onClick={fecharMenu}><Link to="/variacao-custo" className="dropdown-item">VARIAÇÃO DE CUSTO</Link></li>
              <li onClick={fecharMenu}><Link to="/valor-estoque" className="dropdown-item"><FaDollarSign /> VALOR ESTOQUE</Link></li>
              <li onClick={fecharMenu}><Link to="/prediction" className="dropdown-item">PREVISÃO COMPRAS</Link></li>
              <li onClick={fecharMenu}><Link to="/lista-compras" className="dropdown-item"><FaShoppingCart /> LISTA COMPRAS</Link></li>
            </ul>
          </li>

          <li onClick={fecharMenu}>
            <Link to="/fichas-tecnicas" className="nav-link">📋 FICHAS TÉCNICAS</Link>
          </li>

          {/* Dropdown Guia de Produção */}
          <li className={`navbar-dropdown dropdown-right ${dropdownGuia ? "active" : ""}`}>
            <button className="nav-link" onClick={toggleDropdownGuia}>
              🎂 GUIA <FaChevronDown />
            </button>
            <ul className="navbar-dropdown-content">
              {/* Operacional */}
              <li onClick={fecharMenu}>
                <Link to="/guia/montagem" className="dropdown-item">🎂 MONTAGEM DIÁRIA</Link>
              </li>
              <li onClick={fecharMenu}>
                <Link to="/guia/producao" className="dropdown-item">📦 PRODUÇÃO SEMANAL</Link>
              </li>
              {/* Divisor */}
              <li className="dropdown-divider" style={{ borderTop: '1px solid #f0f0f0', margin: '4px 0' }} />
              {/* Cadastro */}
              <li onClick={fecharMenu}>
                <Link to="/guia/tamanhos" className="dropdown-item">📐 TAMANHOS</Link>
              </li>
              <li onClick={fecharMenu}>
                <Link to="/guia/menu-fixo" className="dropdown-item">❄️ MENU FIXO (CONGELADOS)</Link>
              </li>
              <li onClick={fecharMenu}>
                <Link to="/guia/recheios" className="dropdown-item">🍫 RECHEIOS</Link>
              </li>
              <li onClick={fecharMenu}>
                <Link to="/guia/combinacoes" className="dropdown-item">🔀 COMBINAÇÕES</Link>
              </li>
            </ul>
          </li>

          {isAuthenticated && isAdmin && (
            <li onClick={fecharMenu}>
              <Link to="/admin" className="nav-link"><FaUser /> ADMIN</Link>
            </li>
          )}

          <li>
            {isAuthenticated ? (
              <button onClick={handleLogout} className="nav-link logout-btn"><FaSignOutAlt /> SAIR</button>
            ) : (
              <Link to="/login" className="nav-link"><FaSignInAlt /> LOGIN</Link>
            )}
          </li>
        </ul>
      </nav>

      <div className="main-content">
        {/* Conteúdo das páginas aqui */}
      </div>
    </>
  );
};

export default Navbar;